var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainLeft"},[_c('publicColumn',{attrs:{"info":_vm.info}}),_c('publicList',{attrs:{"arr":_vm.data}}),_c('publicPageNumber',{attrs:{"total":_vm.totals,"cur":_vm.cur},on:{"changePage":_vm.getDatas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }